(function () {
var $8fb72785ed872134$exports = {};
document.documentElement.classList.add("js");
/* ---- Nav: background on scroll ---- */ const $8fb72785ed872134$var$nav = document.getElementById("nav");
const $8fb72785ed872134$var$onScroll = ()=>$8fb72785ed872134$var$nav.classList.toggle("is-scrolled", window.scrollY > 24);
$8fb72785ed872134$var$onScroll();
window.addEventListener("scroll", $8fb72785ed872134$var$onScroll, {
    passive: true
});
/* ---- Mobile menu ---- */ const $8fb72785ed872134$var$toggle = document.querySelector(".nav__toggle");
const $8fb72785ed872134$var$mobile = document.getElementById("mobile-menu");
if ($8fb72785ed872134$var$toggle && $8fb72785ed872134$var$mobile) {
    const setOpen = (open)=>{
        $8fb72785ed872134$var$toggle.setAttribute("aria-expanded", String(open));
        $8fb72785ed872134$var$toggle.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu");
        $8fb72785ed872134$var$mobile.hidden = !open;
    };
    $8fb72785ed872134$var$toggle.addEventListener("click", ()=>{
        setOpen($8fb72785ed872134$var$toggle.getAttribute("aria-expanded") !== "true");
    });
    $8fb72785ed872134$var$mobile.addEventListener("click", (e)=>{
        if (e.target.tagName === "A") setOpen(false);
    });
    window.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") setOpen(false);
    });
}
/* ---- Active nav link for the current page ---- */ {
    const page = (location.pathname.split("/").pop() || "index.html").replace(/\.html$/, "") || "index";
    const map = {
        projet: "projets",
        contact: "contact",
        projets: "projets"
    };
    const active = map[page];
    if (active) document.querySelectorAll(`.nav__links a[data-nav="${active}"]`).forEach((a)=>a.setAttribute("aria-current", "page"));
}/* ---- Scroll-in reveals ---- */ const $8fb72785ed872134$var$revealTargets = [
    ".section-label",
    ".skills__grid",
    ".skills .chip--outline-teal",
    ".about__text",
    ".about__cell",
    ".footer__top",
    ".projects__header",
    ".card",
    ".contact__intro",
    ".contact__form",
    ".project__title-wrap",
    ".project__hero",
    ".bloc"
];
const $8fb72785ed872134$var$nodes = document.querySelectorAll($8fb72785ed872134$var$revealTargets.join(","));
$8fb72785ed872134$var$nodes.forEach((n, i)=>{
    n.setAttribute("data-reveal", "");
    n.style.transitionDelay = `${i % 4 * 60}ms`;
});
if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                io.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15,
        rootMargin: "0px 0px -10% 0px"
    });
    $8fb72785ed872134$var$nodes.forEach((n)=>io.observe(n));
    // Safety net: never leave content hidden if the observer misfires.
    setTimeout(()=>{
        $8fb72785ed872134$var$nodes.forEach((n)=>{
            const r = n.getBoundingClientRect();
            if (r.top < window.innerHeight) n.classList.add("is-visible");
        });
    }, 2500);
} else $8fb72785ed872134$var$nodes.forEach((n)=>n.classList.add("is-visible"));
/* ---- Videos: only load + play while on screen (skipped if reduced motion) ---- */ const $8fb72785ed872134$var$reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $8fb72785ed872134$var$videos = document.querySelectorAll(".js-autovideo");
if (!$8fb72785ed872134$var$reducedMotion && $8fb72785ed872134$var$videos.length && "IntersectionObserver" in window) {
    const vio = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const v = entry.target;
            if (entry.isIntersecting) v.play().catch(()=>{});
            else v.pause();
        });
    }, {
        threshold: 0.35
    });
    $8fb72785ed872134$var$videos.forEach((v)=>vio.observe(v));
}
/* ---- Scroll-scrubbed staggered reveal (shared) ---- */ const $8fb72785ed872134$var$clamp01 = (v)=>Math.min(1, Math.max(0, v));
function $8fb72785ed872134$var$scrubReveal(sectionEl, steps, { start: start = 0.82, tail: tail = 0.35, onProgress: onProgress } = {}) {
    if (!sectionEl) return;
    const items = steps.filter((s)=>s.el);
    if ($8fb72785ed872134$var$reducedMotion) {
        items.forEach((s)=>s.el.classList.add("is-in"));
        if (onProgress) onProgress(1);
        return;
    }
    let ticking = false;
    const run = ()=>{
        ticking = false;
        const rect = sectionEl.getBoundingClientRect();
        const vh = window.innerHeight;
        const travel = rect.height + vh * tail;
        const p = $8fb72785ed872134$var$clamp01((vh * start - rect.top) / travel);
        if (onProgress) onProgress(p);
        items.forEach((s)=>s.el.classList.toggle("is-in", p >= s.at));
    };
    const onScroll = ()=>{
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(run);
        }
    };
    run();
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
    window.addEventListener("resize", onScroll);
}
/* Parcours: line drawn + milestones revealed by scroll progression */ const $8fb72785ed872134$var$timelineRow = document.querySelector(".timeline__row");
if ($8fb72785ed872134$var$timelineRow) {
    const ms = [
        ...$8fb72785ed872134$var$timelineRow.querySelectorAll(".milestone")
    ];
    const span = Math.max(1, ms.length - 1);
    $8fb72785ed872134$var$scrubReveal(document.querySelector(".timeline"), ms.map((el, i)=>({
            el: el,
            at: 0.08 + i * (0.5 / span)
        })), {
        onProgress: (p)=>$8fb72785ed872134$var$timelineRow.style.setProperty("--timeline-progress", p.toFixed(3))
    });
    /* Info popup: hover/focus is pure CSS; here we add tap-to-pin for touch */ const closeAll = (except)=>ms.forEach((m)=>m !== except && m.classList.remove("is-open"));
    ms.forEach((m)=>{
        m.addEventListener("click", ()=>{
            const wasOpen = m.classList.contains("is-open");
            closeAll();
            if (!wasOpen) m.classList.add("is-open");
        });
    });
    document.addEventListener("click", (e)=>{
        if (!e.target.closest(".milestone")) closeAll();
    });
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") closeAll();
    });
}
/* Project gallery : scroll-snap natif horizontal, une slide = une "page".
   Le swipe (mobile) et le drag trackpad (desktop) sont gérés directement
   par le navigateur — plus de suivi de touchmove ni de filtrage de clic
   fantôme fait main, qui restait fragile d'un appareil à l'autre (voir
   git log pour l'ancienne implémentation). L'index affiché (dots, flèches,
   vidéo active) est déduit de la position de scroll une fois qu'elle se
   stabilise, ce qui le garde synchro que la navigation vienne d'un clic,
   d'un swipe ou du clavier. */ const $8fb72785ed872134$var$gallery = document.querySelector(".reveal__gallery");
if ($8fb72785ed872134$var$gallery) {
    const section = $8fb72785ed872134$var$gallery.closest(".reveal");
    const slides = [
        ...$8fb72785ed872134$var$gallery.querySelectorAll(".reveal__slide")
    ]; // 5 vraies slides, capturé avant clonage
    const dots = [
        ...section.querySelectorAll(".reveal__dots button")
    ];
    const prevBtn = section.querySelector(".reveal__arrow--prev");
    const nextBtn = section.querySelector(".reveal__arrow--next");
    const count = slides.length;
    const pad = (i)=>String(i + 1).padStart(2, "0");
    // Boucle infinie : un clone (visuel uniquement) du dernier et du premier
    // slide est ajouté à chaque extrémité de la piste physique. Swiper
    // au-delà d'un bout glisse donc naturellement sur ce clone identique,
    // puis une correction de position instantanée et invisible ramène sur
    // le vrai slide une fois le scroll stabilisé — le tour de passe-passe
    // classique des carrousels "infinis". Pas de vidéo ni de lien actif
    // dans les clones (juste le poster en <img>) : ils ne sont visibles
    // qu'une fraction de seconde et sont de toute façon rendus inert.
    const makeClone = (slide)=>{
        const clone = slide.cloneNode(true);
        clone.classList.add("reveal__slide--clone");
        clone.setAttribute("inert", "");
        clone.setAttribute("aria-hidden", "true");
        const video = clone.querySelector("video");
        if (video) {
            const img = document.createElement("img");
            img.src = video.getAttribute("poster");
            img.alt = "";
            video.replaceWith(img);
        }
        return clone;
    };
    $8fb72785ed872134$var$gallery.prepend(makeClone(slides[count - 1]));
    $8fb72785ed872134$var$gallery.append(makeClone(slides[0]));
    const track = [
        ...$8fb72785ed872134$var$gallery.querySelectorAll(".reveal__slide")
    ]; // clone + 5 réelles + clone, ordre physique
    let index = 0;
    let inView = false;
    // position de départ : juste après le clone de tête, sur le vrai slide 01
    $8fb72785ed872134$var$gallery.scrollLeft = $8fb72785ed872134$var$gallery.clientWidth;
    const playActiveVideo = ()=>{
        slides.forEach((s)=>{
            const v = s.querySelector("video");
            if (v) v.pause();
        });
        const v = slides[index].querySelector("video");
        if (v && !$8fb72785ed872134$var$reducedMotion && inView) v.play().catch(()=>{});
    };
    const syncControls = ()=>{
        dots.forEach((d, i)=>d.classList.toggle("is-active", i === index));
        // le nom accessible doit contenir le texte visible (WCAG 2.5.3), donc on
        // met aussi à jour aria-label avec le même numéro que textContent.
        if (prevBtn) {
            const n = pad((index - 1 + count) % count);
            prevBtn.textContent = `\u{2190} ${n}`;
            prevBtn.setAttribute("aria-label", `Projet pr\xe9c\xe9dent \u{2014} ${n}`);
        }
        if (nextBtn) {
            const n = pad((index + 1) % count);
            nextBtn.textContent = `${n} \u{2192}`;
            nextBtn.setAttribute("aria-label", `Projet suivant \u{2014} ${n}`);
        }
        // inert : retire les slides hors-écran du focus / des lecteurs d'écran
        slides.forEach((s, i)=>s.toggleAttribute("inert", i !== index));
    };
    // rawTarget est l'index réel visé, SANS modulo : -1 (prev depuis le
    // premier) ou count (next depuis le dernier) atterrissent naturellement
    // sur le clone adjacent — +1 partout car le clone de tête décale tout
    // d'un cran. La correction vers le vrai slide se fait dans le listener
    // "scroll" une fois stabilisé, une fois que le clone a joué son rôle visuel.
    const goTo = (rawTarget)=>{
        $8fb72785ed872134$var$gallery.scrollTo({
            left: (rawTarget + 1) * $8fb72785ed872134$var$gallery.clientWidth,
            behavior: $8fb72785ed872134$var$reducedMotion ? "auto" : "smooth"
        });
    // index/syncControls/vidéo se mettent à jour via l'écouteur "scroll"
    // ci-dessous une fois le scroll retombé — même chemin qu'un swipe manuel.
    };
    if (prevBtn) prevBtn.addEventListener("click", ()=>goTo(index - 1));
    if (nextBtn) nextBtn.addEventListener("click", ()=>goTo(index + 1));
    dots.forEach((d, i)=>d.addEventListener("click", ()=>goTo(i)));
    window.addEventListener("keydown", (e)=>{
        if (!inView) return;
        if (e.key === "ArrowRight") goTo(index + 1);
        if (e.key === "ArrowLeft") goTo(index - 1);
    });
    // Fondu en continu pendant le scroll : la slide qui sort/entre s'estompe
    // proportionnellement à sa distance au point d'alignement, aussi bien au
    // doigt qu'en cliquant une flèche (les deux déclenchent "scroll"). Sur la
    // piste complète (clones compris) pour rester juste pendant la transition
    // aux extrémités. Pas de transition CSS ici — l'opacité doit coller
    // exactement à la position du scroll à chaque frame, une transition la
    // ferait juste traîner derrière.
    let fadeRaf = null;
    const updateFade = ()=>{
        fadeRaf = null;
        const cw = $8fb72785ed872134$var$gallery.clientWidth;
        const scrollLeft = $8fb72785ed872134$var$gallery.scrollLeft;
        track.forEach((s, i)=>{
            const dist = Math.abs(scrollLeft - i * cw) / cw;
            s.style.opacity = Math.max(0, 1 - dist).toFixed(3);
        });
    };
    // Débounce sur "scroll" : on attend que le scroll (swipe, drag, ou notre
    // propre scrollTo) se stabilise avant de recalculer l'index affiché — et,
    // sur les clones, avant de corriger la position vers le vrai slide.
    let scrollSettleTimer;
    $8fb72785ed872134$var$gallery.addEventListener("scroll", ()=>{
        if (!$8fb72785ed872134$var$reducedMotion && fadeRaf === null) fadeRaf = requestAnimationFrame(updateFade);
        clearTimeout(scrollSettleTimer);
        scrollSettleTimer = window.setTimeout(()=>{
            const physical = Math.round($8fb72785ed872134$var$gallery.scrollLeft / $8fb72785ed872134$var$gallery.clientWidth);
            if (physical === 0) {
                // atterri sur le clone de tête (= dernier slide) : correction
                // invisible vers le vrai dernier slide, pixel pour pixel identique.
                $8fb72785ed872134$var$gallery.scrollLeft = count * $8fb72785ed872134$var$gallery.clientWidth;
                index = count - 1;
                syncControls();
                playActiveVideo();
            } else if (physical === count + 1) {
                $8fb72785ed872134$var$gallery.scrollLeft = 1 * $8fb72785ed872134$var$gallery.clientWidth;
                index = 0;
                syncControls();
                playActiveVideo();
            } else {
                const settled = physical - 1;
                if (settled !== index && settled >= 0 && settled < count) {
                    index = settled;
                    syncControls();
                    playActiveVideo();
                }
            }
        }, 100);
    }, {
        passive: true
    });
    // Entrée : la galerie apparaît (fondu + léger décalage) quand la section
    // approche du viewport — avec filet de sécurité.
    const reveal = ()=>section.classList.add("is-revealed");
    if ($8fb72785ed872134$var$reducedMotion) reveal();
    else if ("IntersectionObserver" in window) {
        const io = new IntersectionObserver((entries)=>{
            if (entries.some((e)=>e.isIntersecting)) {
                reveal();
                io.disconnect();
            }
        }, {
            rootMargin: "0px 0px -12% 0px"
        });
        io.observe(section);
        window.setTimeout(()=>{
            if (section.getBoundingClientRect().top < window.innerHeight) reveal();
        }, 2000);
    } else reveal();
    // Suivi de visibilité : gère la lecture vidéo + les flèches clavier.
    if ("IntersectionObserver" in window) new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            inView = entry.isIntersecting;
            if (inView) playActiveVideo();
            else {
                const v = slides[index].querySelector("video");
                if (v) v.pause();
            }
        });
    }, {
        threshold: 0.3
    }).observe(section);
    else inView = true;
    syncControls();
}
/* ---- Projets: filter grid ---- */ const $8fb72785ed872134$var$filters = document.querySelectorAll(".projects__filters .filter");
const $8fb72785ed872134$var$cards = document.querySelectorAll(".projects__list .card");
if ($8fb72785ed872134$var$filters.length) $8fb72785ed872134$var$filters.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        const f = btn.dataset.filter;
        $8fb72785ed872134$var$filters.forEach((b)=>{
            const on = b === btn;
            b.classList.toggle("is-active", on);
            b.setAttribute("aria-pressed", String(on));
        });
        $8fb72785ed872134$var$cards.forEach((c)=>{
            c.hidden = f !== "all" && c.dataset.cat !== f;
            if (!c.hidden) c.classList.add("is-visible");
        });
    });
});
/* ---- Contact: build a mailto from the form ---- */ const $8fb72785ed872134$var$form = document.getElementById("contact-form");
if ($8fb72785ed872134$var$form) {
    const note = $8fb72785ed872134$var$form.querySelector(".contact__form-note");
    $8fb72785ed872134$var$form.addEventListener("submit", (e)=>{
        e.preventDefault();
        if (!$8fb72785ed872134$var$form.reportValidity()) return;
        const data = new FormData($8fb72785ed872134$var$form);
        const nom = (data.get("nom") || "").toString().trim();
        const email = (data.get("email") || "").toString().trim();
        const type = (data.get("type") || "").toString().trim();
        const message = (data.get("message") || "").toString().trim();
        const subject = `Contact portfolio${type ? ` \u{2014} ${type}` : ""}`;
        const body = [
            `Nom : ${nom}`,
            `Email : ${email}`,
            type ? `Type de projet : ${type}` : null,
            "",
            message
        ].filter((l)=>l !== null).join("\n");
        window.location.href = `mailto:studio@sloowresound.ch?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        if (note) {
            note.hidden = false;
            note.textContent = "Votre logiciel de messagerie va s'ouvrir\u2026";
        }
    });
}

})();
//# sourceMappingURL=404.7706595b.js.map
